/**
 * Cookie configuration constants
 */
export const COOKIE_CONFIG = {
  // Cookie names
  ACCESS_TOKEN_COOKIE: 'adminAccessToken',
  REFRESH_TOKEN_COOKIE: 'adminRefreshToken',
  
  // Cookie expiry in days
  SHORT_EXPIRY_DAYS: 1,     // 1 day for session-only
  LONG_EXPIRY_DAYS: 30,     // 30 days for "stay signed in"
}; 